// Polyfill para módulo 'util' do Node.js
// Usado por react-render-html/parse5 no browser

export const inherits = function(ctor, superCtor) {
  if (superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  }
};

export const inspect = function(obj, options) {
  return JSON.stringify(obj, null, 2);
};

export default {
  inherits,
  inspect,
};
